
<template>
  <div class="main-layout">
    <top-bar></top-bar>
    <div class="body-content">
      <router-view></router-view>
      <!-- <div flex="cross:center main:center" class="bg-white w-p-100 h-p-100 content">
    <div class="m-b-100 img">
      <img src="@/assets/imgs/not-found-404.png" alt="404">
      <div class="text"><span>抱歉,您访问的页面不存在</span></div>
      <div > <el-button @click="golink" type="primary" >返回主菜单</el-button></div>
    
    </div>
  </div> -->
    </div>
  </div>
</template>

<script>
import TopBar from "@/modules/main/view/layout/TopBar";
import SideBar from "@/modules/main/view/layout/SideBar";
// import { utils } from "@/utils/utils";
// import { cooperativeUrl } from "@domain";

export default {
  components: { TopBar, SideBar },
  data () {
    return {
      isFold: true
    };
  },
  created () {
    window.location.href = '/';
  },
  methods: {
    changeHandle (val) {
      this.isFold = val;
    },

    // golink () {
    //   let isMainLogin = utils.getCookie("_need_main_username_");
    //   console.log(isMainLogin);
    //   if (isMainLogin !== "true") {
    //     this.$router.push({ path: "/user-center/account/base-info" });
    //   } else {
    //     this.$router.push({ path: "/" });
    //   }
    //   // 默认跳转到欢迎页
    //   // this.$router.push({path: "/"});
    // }
  }
};
</script>

<style lang="scss" scoped>
.main-layout {
  min-width: 1356px;
  // min-width: 1366px;
  .body-content {
    width: 100%;
    overflow: hidden;
    background: rgba(244, 247, 252, 1);
    height: calc(100vh - 52px); //delete by zjj
    //min-height: 500px;
    .content-wrap {
      //overflow-y: auto;
      float: right;
      width: calc(100% - 220px);
      // height: 101%;
    }
    .content-wrap.fold {
      float: right;
      width: calc(100% - 48px);
      transition: all 0.1s ease, 0.1s ease;
    }

    .main-page-scroll {
      // height: 101%;
      overflow-y: auto;
    }
    .content {
      width: calc(100% - 200px);
      margin-top: 78px;
      margin-left: 100px;
      height: calc(100vh - 150px);
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px 0px rgba(33, 76, 217, 0.2);
      .img {
        text-align: center;
        img {
          margin-top: 96px;
        }
        .text {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(33, 42, 64, 1);
          margin-top: 33px;
          margin-bottom: 33px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/modules/main/view/layout/Page404.vue